<template>
  <div class="matching-to-pay-wrapper" :style="`paddingTop:${barHeight}px`">
    <div class="content-wrapper">
      <!-- 返回键 -->
      <img class="back" src="./images/back.webp" alt="back" width="24" height="24" @click="closeWeb" />
      <!-- 标题 -->
      <div class="title-wrapper">
        <span class="text">{{ $t('lang.MatchingToPay.k006') }}</span>
        <img :src="getMatchImg('beans')" alt="image" width="46px" height="46px" />
      </div>
      <!-- 副标题 -->
      <div class="subtitle-wrapper">
        <span>{{ $t('lang.MatchingToPay.k001') }}&nbsp;</span>
        <span class="number">30</span>
        <span>{{ $t('lang.MatchingToPay.k002') }}</span>
      </div>
      <!-- 内容 -->
      <div class="text-wrapper">
        <div class="text-layout-wrapper">
          <div class="layout-wrapper">
            <p class="text">
              <span>{{ $t('lang.MatchingToPay.k003') }}</span>
              <img class="coin" :src="getMatchImg('beans')" alt="image" />
              <span>{{ $t('lang.MatchingToPay.k004') }}</span>
            </p>
            <br />
            <p class="text">{{ $t('lang.MatchingToPay.k005') }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'matching-to-pay',
}
</script>

<style lang="scss" scoped>
@import './styles/index.scss';
</style>
